export enum EAcaoType {
  CANCELAR = 'CANCELAR',
  CONFIRMAR = 'CONFIRMAR',
  INFORMAR = 'INFORMAR'
}
